import { Common } from '@stockbit/ui';
import styled from 'styled-components';

const { Flex } = Common;

interface ContainerProps {
  isSplitOrder?: boolean;
}

export const Container = styled.div<ContainerProps>`
  background-color: ${({ isSplitOrder }) => (isSplitOrder ? '#f2f1fe' : '')};
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
`;

export const TotalLotWrapper = styled(Flex)`
  width: 100%;
  justify-content: space-between;
`;

export const ListWrapper = styled(Flex)`
  margin-top: 12px;
  width: 100%;
  flex-direction: column;

  & > div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;

    &:last-child {
      margin: 0;
    }

    & > p {
      color: #969696;
    }
  }
`;
